// WithMessagePinData.js
import { connect } from 'react-redux';

import WithMessagePinData from '../component/WithMessagePinData.jsx';

import getListData from '../selector/getListData.js';
import getMessageData from '../selector/getMessageData.js';
import getFeedName from '../selector/getFeedName.js';

import { PROFILE_FEED_REMOTE_CONFIG_KEY_MAP } from '../resource/profileConstants.js';
import { getFeedNameType, sanitizeFeedQuery } from '../resource/feedUtils.js';

const mapStateToProps = (state, { messageId, profileListType }) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const feedRemoteConfigKey =
    PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[profileListType];
  const baseFeedName = senderId
    ? getFeedName(state, feedRemoteConfigKey, '{USER_ID}', senderId)
    : '';
  const feedNameWithQuery = sanitizeFeedQuery({ feedName: baseFeedName });
  return {
    messageId,
    pinnedItemIds: getListData(
      state,
      [
        'home',
        getFeedNameType({ feedName: feedNameWithQuery }),
        feedNameWithQuery,
        'pinned',
      ],
      'itemIds'
    ),
  };
};

export default connect(mapStateToProps)(WithMessagePinData);
